import { XPDF } from '@xometry/xpdf';
import { makeAbsoluteRoute } from 'common/routes';
import { FC } from 'react';

import s from './PdfViewer.module.less';

interface Props {
  src: string;
}

const DTI = 'PDFViewer';
const packageURL = makeAbsoluteRoute('/pdfjs/2_6_242_legacy/web/viewer.html');

const PdfViewer: FC<Props> = ({ src }) => {
  return <XPDF title="" fileURL={src} packageURL={packageURL} data-testid={DTI} className={s.wrapper} />;
};

export default PdfViewer;
